module.exports = __webpack_public_path__ + "static/feedback-content-08037aff838ec1371ccf96e8b2f0fda0.png";